import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import slovenianAnimals from "#/translations/domain/animals/slovenianAnimals";
import importSlovenian from "#/translations/domain/import/slovenian";
import slovenianCommon from "#/translations/slovenian";
import "#/translations/yup/slovenian";
import english from "@/translations/english";
import slovenian from "@/translations/slovenian";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      sl: {
        translation: {
          ...slovenianCommon,
          ...slovenianAnimals,
          ...importSlovenian,
          ...slovenian,
        },
      },
      en: { translation: english },
    },
    lng: "sl",
  })
  .then();

export default i18n;
